<template>
  <div class="mask" v-if="maskShow">
    <div class="ivu-modal" :style="'width:' + width + 'px;'">
      <div class="content">
        <div class="icon" @click="closeModel">
          <Icon type="close-circled" class="close"></Icon>
        </div>
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "MaskModel",
  props: {
    maskShow: {
      type: Boolean,
      default: false
    },
    width: {
      type: Number,
      default: 800
    }
  },
  methods: {
    closeModel() {
      this.$emit("on-cancel", false);
    }
  }
};
</script>

<style lang="stylus" scoped>
.mask
  position fixed
  top 0
  background rgba(0, 0, 0, .5)
  left 0
  right 0
  bottom 0
  z-index 1000
  .ivu-modal
    position relative
    margin 0 auto
    background #fff
    top 100px
    border-radius 5px
    .content
      background #fff
      padding 10px
      border-radius 8px
      text-align center
      position relative
      .icon
        position absolute
        top 10px
        right 10px
        width 2em
        height 2em
        cursor pointer
        .close
          font-size 20px
</style>
